import type { Story } from '@/mocks/featuredStories';
import Section from './Section';
import StoryCover from './StoryCover';

interface Props {
  stories: Story[];
  onOpen: (s: Story) => void;
}

const TOP_FEEL: Record<string, string> = {
  'yanchuhui-yinle-pan': '现象级',
  'liuxingyuan-shenshi': '讨论热',
  'lianyi-gaoxiao-wu': '热搜王',
  'guochan-xiju-dianshi': '口碑款',
  'zhoudian-dianying-qi': '黑马',
  'jingji-ren-nianhuo': '风向标',
};

export default function Monthly({ stories, onOpen }: Props) {
  return (
    <Section
      id="monthly"
      icon="ri-group-line"
      title="本月最劲爆"
      en="HOTTEST THIS MONTH"
      desc="每月更新的爆款雷达，为你锁定本月话题度、讨论度与传播度最高的娱乐大瓜，不让你缺席任何一场集体围观。"
      right={
        <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
          <i className="ri-sound-module-line" /> 本月雷达持续探测中
        </span>
      }
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stories.map((s, i) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onOpen(s)}
            className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 text-left transition hover:-translate-y-1 hover:border-primary-300 hover:shadow-sm"
          >
            <div className="relative aspect-[3/2] w-full overflow-hidden">
              <StoryCover story={s} className="transition duration-500 group-hover:scale-105" />
              <span className="absolute left-3 top-3 flex items-center gap-1 rounded bg-foreground-950/85 px-2 py-0.5 text-[11px] font-bold text-accent-400">
                <i className="ri-arrow-up-double-fill" /> TOP {i + 1}
              </span>
              <span className="absolute right-3 top-3 rounded bg-background-50/95 px-1.5 py-0.5 text-[11px] font-medium text-primary-700">
                {s.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                {s.title}
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{s.dek}</p>
              <div className="mt-3 flex items-center justify-between border-t border-dashed border-background-300 pt-3 text-xs">
                <span className="flex items-center gap-1 font-medium text-accent-700">
                  <i className="ri-fire-fill" /> {s.heat} 热度
                </span>
                <span className="text-foreground-500">{s.timeLabel}</span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </Section>
  );
}